import { Button, Flex, IconWithVariant, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import { FontSizes } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const SuccessBox = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { currentType, partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    return (
        <Flex
            alignItems="center"
            flexDirection="column"
            mt={5}
            mb={5}
            p={4}
            backgroundColor={theme.palette.onboarding.backgroundColorGray}
            width="100%"
            justifyContent="space-between"
        >
            <Flex flexDirection="column" alignItems="center" mt={2}>
                <IconWithVariant
                    src="Success"
                    size={FontSizes[5]}
                    variant="secondary"
                />
                <Text
                    color={theme.palette.onboarding.cardBodyText}
                    fontSize={3}
                    mt={4}
                    textAlign="center"
                >
                    {t('Onboarding.quickScanResults.title')}
                </Text>
                <Text
                    color={theme.palette.onboarding.cardBodyText}
                    fontSize={1}
                    mt={3}
                >
                    {t('Onboarding.quickScanResults.description')}
                </Text>
            </Flex>
            <Link
                to={`${basePartnerRoute}/organizations`}
                style={{
                    alignSelf: 'center',
                    marginTop: '32px'
                }}
                data-trackid={`${currentType}SuccessContinueBtn_routeTo`}
            >
                <Button
                    data-testid={`${currentType}SuccessContinueBtn`}
                    data-trackid={`${currentType}SuccessContinueBtn`}
                >
                    {t('Onboarding.successStep.box.button')}
                </Button>
            </Link>
        </Flex>
    );
};
